import types from '../../constants';
import { connect } from '../../socket';

export function openSocketConnection() {
  return async (dispatch) => {
    dispatch({ type: types.SOCKET_CONNECTING });

    connect(() => {
      dispatch({ type: types.SOCKET_CONNECTED });
    });
  };
}
